import { useQuery } from '@tanstack/react-query';

import getUserDetail from 'Api/user/getUserDetail';
import getUserDetailResponse from './model/response/getUserDetailResponse';

const useGetUserDetail = (id) => {
  return useQuery({
    queryKey: ['user', id],
    queryFn: async () => {
      const response = await getUserDetail(id);
      return getUserDetailResponse(response);
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetUserDetail;
